import React, { useMemo } from "react";
import { GraficaBarrasPiezas } from "../Cortes/GraficaPendientesTaller";

// (2026-10) Gráfica del recuadro "Por Cortar" de ListadoOrdenesCorte: piezas
// que faltan por cortar por cliente, de mayor a menor. Recibe un renglón por
// orden sin cortar (GET ordenesCorteKpisDetalle → porCortar), los mismos que
// suma el recuadro, así que el total cuadra con él.

// Piezas por cortar por cliente; "vencidas" = las de órdenes cuya fecha de
// entrega del pedido ya pasó.
export const agrupaPorCliente = (filas, hoy) => {
  const m = new Map();
  (filas || []).forEach((f) => {
    const piezas = Number(f.piezas || 0);
    if (piezas <= 0) return;
    const nombre = String(f.cliente || "").trim() || "Sin cliente";
    const k = f.idCliente || nombre;
    if (!m.has(k)) {
      m.set(k, { id: f.idCliente || "", cliente: nombre, piezas: 0, vencidas: 0, ordenes: [] });
    }
    const g = m.get(k);
    g.piezas += piezas;
    if (f.fechaEntrega && String(f.fechaEntrega).slice(0, 10) < hoy) g.vencidas += piezas;
    g.ordenes.push({ numero: String(f.numero || "").trim() || "Sin número", piezas });
  });
  return [...m.values()].sort((a, b) => b.piezas - a.piezas);
};

function GraficaPorCortarCliente({ filas, hoy }) {
  const grupos = useMemo(() => agrupaPorCliente(filas, hoy), [filas, hoy]);

  const totales = grupos.reduce(
    (t, g) => ({
      piezas: t.piezas + g.piezas,
      ordenes: t.ordenes + g.ordenes.length,
      vencidas: t.vencidas + g.vencidas,
    }),
    { piezas: 0, ordenes: 0, vencidas: 0 }
  );
  const pctVencidas =
    totales.piezas > 0 ? Math.round((totales.vencidas / totales.piezas) * 100) : 0;

  const datos = grupos.map((g) => ({
    id: g.id,
    nombre: g.cliente,
    valor: g.piezas,
    secciones: [
      [
        { etiqueta: "Órdenes sin cortar", valor: g.ordenes.length },
        { etiqueta: "Vencidas", valor: g.vencidas, critico: true },
      ],
      // las OP con más piezas por cortar (una OP trae una orden por artículo,
      // así que se juntan por número)
      [
        ...g.ordenes
          .reduce(
            (m, o) => m.set(o.numero, (m.get(o.numero) || 0) + o.piezas),
            new Map()
          )
          .entries(),
      ]
        .sort((a, b) => b[1] - a[1])
        .slice(0, 5)
        .map(([numero, piezas]) => ({ etiqueta: `OP ${numero}`, valor: piezas })),
    ],
  }));

  return (
    <GraficaBarrasPiezas
      tiles={[
        { etiqueta: "Piezas por cortar", valor: totales.piezas, pie: "en órdenes sin cortar" },
        { etiqueta: "Clientes con pendiente", valor: grupos.length, pie: "con al menos una pieza" },
        { etiqueta: "Órdenes sin cortar", valor: totales.ordenes, pie: "órdenes de producción activas" },
        {
          etiqueta: "Piezas vencidas",
          valor: totales.vencidas,
          pie: `${pctVencidas}% de lo por cortar, con fecha de entrega pasada`,
          critico: true,
        },
      ]}
      titulo="Piezas por cortar por cliente"
      subtitulo="De mayor a menor · Pasa el cursor sobre un cliente para ver sus órdenes"
      ejeTitulo="Piezas pendientes de cortar"
      unidad="piezas por cortar"
      vacio="No hay piezas pendientes de cortar."
      datos={datos}
    />
  );
}

export default GraficaPorCortarCliente;
